/**
 * Carrousel d'images (réalisations entrepreneur, photos projet) — tiny-slider.
 * Build : entrée Webpack `js/cc-gallery-slider` → themes/.../assets/js/cc-gallery-slider.js
 */
import { tns } from 'tiny-slider';

(function () {
    'use strict';

    function syncControlsVisibility(instance, controls) {
        if (!controls || !instance || typeof instance.getInfo !== 'function') {
            return;
        }

        var info = instance.getInfo();
        var hideControls = !info || info.slideCount <= info.items;

        controls.classList.toggle('is-hidden', hideControls);
        controls.setAttribute('aria-hidden', hideControls ? 'true' : 'false');
    }

    function initGallerySlider(container) {
        if (!container || container.dataset.sliderReady === '1') {
            return;
        }

        container.dataset.sliderReady = '1';

        var wrapper = container.closest('.cc-fiche-realisations__slider');
        var controls = wrapper ? wrapper.querySelector('.cc-fiche-realisations__controls') : null;
        var slideCount = container.querySelectorAll('.cc-fiche-realisations__slide').length;
        var maxCenteredSlides = 3;

        if (slideCount <= maxCenteredSlides) {
            if (wrapper) {
                wrapper.classList.add('is-few-slides');
            }
            if (controls) {
                controls.classList.add('is-hidden');
                controls.setAttribute('aria-hidden', 'true');
            }
            return;
        }

        var instance = tns({
            container: container,
            items: 1,
            slideBy: 1,
            gutter: 20,
            loop: true,
            nav: false,
            mouseDrag: true,
            controls: true,
            controlsContainer: controls || false,
            responsive: {
                640: { items: 2 },
                1180: { items: 2 },
                1280: { items: 3 },
            },
        });

        if (!controls || !instance) {
            return;
        }

        syncControlsVisibility(instance, controls);
        instance.events.on('indexChanged', function () {
            syncControlsVisibility(instance, controls);
        });
        window.addEventListener('resize', function () {
            syncControlsVisibility(instance, controls);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-cc-gallery-slider]').forEach(initGallerySlider);
    });
})();
